// extracted by mini-css-extract-plugin
export default {"container":"AuthForm_container__GmkaI","form":"AuthForm_form__tnEMq","inputs":"AuthForm_inputs__lhR87","loginError":"AuthForm_loginError__WajOi"};